import type { RouteTab } from '@/shared/ui/route-tabs';

export const SIGNALS_ROUTES = {
  overview: '/dashboard/signals',
  categories: '/dashboard/signals/categories',
  kinds: '/dashboard/signals/kinds',
  list: '/dashboard/signals/list',
} as const;

export const SIGNALS_TABS: RouteTab[] = [
  { label: 'Overview', href: SIGNALS_ROUTES.overview },
  { label: 'Categories', href: SIGNALS_ROUTES.categories },
  { label: 'Kind scopes', href: SIGNALS_ROUTES.kinds },
  { label: 'Signal list', href: SIGNALS_ROUTES.list },
];
